<template>
	<div class="p-3">
		<!-- 页面顶部日历选择器 -->
		<div class="date-selector" style="text-align: left; padding: 0px 0; border-bottom: 1px solid var(--border-color); margin-bottom: 0px; display: flex; align-items: center; justify-content: left;">
			<b-form-datepicker 
				size="sm" 
				@context="onDateChange" 
				v-model="selectedEndDate" 
				class="mb-1" 
				today-button 
				close-button 
				locale="zh" 
				:date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric', weekday: 'short' }"
				style="width: 150px; flex-shrink: 0;">
			</b-form-datepicker>
			
			<span style="margin-left: 15px; font-size: 14px; color: var(--text-muted); white-space: nowrap;">显示最近 {{dayn}} 个交易日</span>
		</div>

		
		<div class="row">
			<template v-if="days && days.length">
				<RatePlate v-for="day in days" :date1="day" :key="day + '-' + selectedEndDate" :plate_type=17
					:selectedPlateCode="selectedPlateCode" @plate-selected="handlePlateSelected" :showUplimitStep=1 :show_score="1"
					@show_sidebar="show_sidebar" @first-plate-loaded="handleFirstPlateLoaded" @show-plate-kline="handleShowPlateKline">
				</RatePlate>
			</template>
		</div>

		<!-- 板块K线图（组件化） -->
		<PlateKlineModal
			:visible="showPlateKline"
			:plateCode="selectedPlateCode"
			:plateName="selectedPlateName"
			:selectedDate="selectedDate"
			@close="closePlateKline"
		/>

		<StockInfoSidebar :symbol_code="symbol_code" :symbol_name="symbol_name" :date_mark="date_mark"></StockInfoSidebar>
		<div class="mt-2 text-muted small">感谢<router-link to="/contact" class="text-accent font-weight-bold">捐赠</router-link>服务器费用</div>

	</div>

</template>

<script>
	import moment from 'moment';
	import RatePlate from 'components/plate/RatePlate.vue'
	import StockInfoSidebar from 'components/stock/StockInfoSidebar.vue'
	import PlateKlineModal from 'components/plate/PlateKlineModal.vue'

	import {
		request_zzquant
	} from "network/request.js"

	export default {
		data() {
			return {
				selectedPlateCode: "",
				selectedPlateName: "",
				showPlateKline: false,
				firstPlateSet: false, // 添加标志位，确保只设置一次
				days: [],
				dayn: 10,
				symbol_name: "",
				symbol_code: "",
				selectedDate: null,
				date_mark: "",
				selectedEndDate: (() => {
					const now = moment();
					const currentTime = now.format('HH:mm');					
					if (currentTime < '09:31'){
						return now.format('YYYY-MM-DD');
					} else {
						return now.add(1, 'days').format('YYYY-MM-DD');
					}
				})(),
			};
		},
		created() {
			const days_n = this.$route.query.dayn || 10 // 使用 query 而不是 params
			this.dayn = parseInt(days_n) // 确保是数字类型
		},
		mounted() {
			this.get_trade_days();
		},
		components: {
			RatePlate,
			StockInfoSidebar,
			PlateKlineModal
		},
		methods: {
			// 日期选择变化处理
			onDateChange() {
				// 重置选中状态
				this.selectedPlateCode = "";
				this.firstPlateSet = false;
				
				// 触发数据刷新
				this.get_trade_days();
			},
			
			handlePlateSelected(plateCode) {
				this.selectedPlateCode = plateCode
			},
			handleFirstPlateLoaded(plateCode, date) {
				// 只在第一次加载时设置默认选中的plate_code
				if (!this.firstPlateSet && this.days &&this.days.length > 0 && date === this.days[0]) {
					this.selectedPlateCode = plateCode;
					this.firstPlateSet = true;
				}
			},
			handleShowKline(stock_code, stock_name) {
				this.symbol_code = stock_code
				this.symbol_name = stock_name
			},
			handleDateSelected(date) {
				this.selectedDate = date
			},
        show_sidebar(stock_info) {
            this.symbol_code = stock_info['stock_code'];
            this.symbol_name = stock_info['stock_name'];
            this.date_mark = stock_info['date1'];
        },
			get_trade_days() {
				// 使用选中的日期作为结束日期
				const today = this.selectedEndDate;
				request_zzquant({
						url: '/market/trade/days?day_end=' + today + '&days=' + this.dayn
					})
					.then(res1 => {
						this.days = res1['data']['data'].slice().reverse();
						this.selectedDate = this.days[1]
					})
					.catch(err => {
						console.log(err);
					});
			},
			
			// 处理板块K线图显示
			handleShowPlateKline(plateInfo) {
				this.selectedPlateCode = plateInfo.code;
				this.selectedPlateName = plateInfo.name;
				this.showPlateKline = true;
			},
			
			// 关闭板块K线图
			closePlateKline() {
				this.showPlateKline = false;
			}
		}
	}
</script>

<style>
	.date-selector input[type="date"]:focus {
		border-color: #007bff;
		box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
	}
	
	.date-selector input[type="date"]:hover {
		border-color: #999;
	}
</style>

<style scoped>
/* 页面级样式，模态样式已封装到 PlateKlineModal 组件内 */
</style>
